import React, { useCallback } from 'react';
import { DataWithLoadingState } from '../../../../../../utils/dataWithLoadingState';
import {
  AddEmployeeSkillDialog,
  Props as AddEmployeeSkillDialogProps,
} from '../../../Skills/dialog/AddEmployeeSkillDialog';
import { Skill, SkillLevel } from '../../../Skills/common/types';
import { useAddProjectSkill } from './useProjectSkillsMutations';

type Props = Omit<
  AddEmployeeSkillDialogProps,
  'onSkillAdded' | 'inProgress' | 'availableSkills' | 'isSelfView'
> & {
  projectId: string;
  availableSkills: DataWithLoadingState<Skill>;
};

export const AddProjectSkillDialogConnected: React.FC<
  React.PropsWithChildren<Props>
> = (props) => {
  if (!props.show) {
    return null;
  }
  return <Content {...props} />;
};

const Content: React.FC<React.PropsWithChildren<Props>> = ({
  projectId,
  ...props
}) => {
  const { onClose } = props;
  const { addProjectSkill, inProgress } = useAddProjectSkill();

  const handleSkillAdded = useCallback(
    (
      skillId: string,
      rate: SkillLevel | undefined,
      monthsExperience: number | null,
    ) => {
      addProjectSkill({
        skillId,
        projectId,
        rate: rate ?? null,
        monthsExperience,
      }).then((ok) => {
        if (ok) onClose();
      });
    },
    [addProjectSkill, projectId, onClose],
  );

  return (
    <AddEmployeeSkillDialog
      {...props}
      translationNamespace="skills.addProjectSkill"
      isSelfView={false}
      inProgress={inProgress}
      onSkillAdded={handleSkillAdded}
    />
  );
};
